/**
 * Get Bongo URL from webpack DefinePlugin or fallback
 *
 * The BONGO_URL is injected at build time via webpack's DefinePlugin from process.env.BONGO_URL.
 * For HGInsights deployments, BONGO_HGINSIGHTS_URL is used when the hostname contains '.hginsights'.
 *
 * Configuration:
 * - Set BONGO_URL environment variable before building/running
 * - Set BONGO_HGINSIGHTS_URL environment variable for HGInsights deployments
 * - In development: defaults to http://localhost:3000 if not set via environment variable
 * - In production: must be set via environment variable (no fallback)
 *
 * Example:
 *   BONGO_URL=http://localhost:3000 npm run dev
 */
export function getBongoUrl(): string {
  // Check if hostname contains '.hginsights' and use HGInsights-specific URL
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isHgInsights = hostname.includes('.hginsights');

    if (isHgInsights) {
      if (
        typeof BONGO_HGINSIGHTS_URL !== 'undefined' &&
        BONGO_HGINSIGHTS_URL &&
        BONGO_HGINSIGHTS_URL !== 'undefined'
      ) {
        return BONGO_HGINSIGHTS_URL;
      }
    }
  }

  // Check if BONGO_URL is defined and not the string "undefined" (which happens when process.env.BONGO_URL is undefined)
  if (
    typeof BONGO_URL !== 'undefined' &&
    BONGO_URL &&
    BONGO_URL !== 'undefined'
  ) {
    return BONGO_URL;
  }

  // Fallback for development when BONGO_URL environment variable is not set
  // This allows local development without requiring BONGO_URL to be set
  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  ) {
    return 'http://localhost:3000';
  }

  // Production fallback (should not be reached if environment variables are properly configured)
  return 'https://bongo-staging.hginsights.info';
}
